/**
 * Enum representing the names of layers used for bounding box (BBox) drawing in the application.
 * These layers are used to visualize bounding boxes and their components, such as lines.
 */
export enum LayerName {
	/** The layer name for the bounding box area. */
	BBOX = 'bboxLayer',

	/** The layer name for the bounding box boundary lines. */
	BBOX_LINES = 'bboxLayer-lines',
}